import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getInfoByType } from 'services/info';
import Info from 'services/info/models/info-interface';
import { PlayerSambaVideos } from 'components';
import PregnantIcon from 'assets/icon/icone gravida.svg';
import Star from 'assets/icon/Vector.svg';
import Heart from 'assets/icon/g1627.svg';
import { MessageCircle, Play } from 'lucide-react';

import pregnantImage from 'assets/LandingPage/1.png';
import pregnantImage2 from 'assets/LandingPage/2.png';
import pregnantImage3 from 'assets/LandingPage/3.png';
import pregnantImage4 from 'assets/LandingPage/4.png';
import pregnantImage5 from 'assets/LandingPage/5.png';

import {
  Container,
  MaxWidth,
  Flex,
  LeftContent,
  TextSection,
  Title,
  Highlight,
  Subtitle,
  StatsGrid,
  StatItem,
  StatIcon,
  StatNumber,
  StatLabel,
  ButtonSection,
  ButtonContainer,
  PrimaryButton,
  SecondaryButton,
  FreeText,
  ImagesGrid,
  LargeImage,
  SmallImagesRight,
  BottomImages,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  CloseButton
} from './style';

export default function WelcomeVideo() {
  const history = useHistory();
  const [modalOpen, setModalOpen] = useState(false);
  
  const [welcomeVideo, setWelcomeVideo] = useState<Array<Info>>();

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  useEffect(() => {
    (async () => {
      let localVideo;
      const user = JSON.parse(localStorage.getItem('exeltis-user') as string);

      if (user) {
        localVideo = await getInfoByType('WELCOME_VIDEO');
      } else {
        const token = 'Bearer ' + process.env.REACT_APP_UNLOGGED_TOKEN;
        localVideo = await getInfoByType('WELCOME_VIDEO', {
          Authorization: token,
        });
      }

      setWelcomeVideo(localVideo);
    })();
  }, []);
  return (
    <Container>
      <MaxWidth>
        <Flex>
          {/* Left Content */}
          <LeftContent>
            <TextSection>
              <Title>
                Uma preparação completa para a sua
                <Highlight> jornada da gestação</Highlight>
              </Title>
              <Subtitle>
                O melhor e mais completo curso de gestante, criado por
                profissionais experientes, com conteúdos 100% online e gratuitos
              </Subtitle>
            </TextSection>

            {/* Stats */}
            <StatsGrid>
              <StatItem>
                <StatIcon>
                  <img src={PregnantIcon} alt="Gestante" />
                </StatIcon>
                <StatNumber>43</StatNumber>
                <StatLabel>Aulas</StatLabel>
              </StatItem>

              <StatItem>
                <StatIcon>
                  <img src={Star} alt="Avaliação" />
                </StatIcon>
                <StatNumber>14</StatNumber>
                <StatLabel>Especialistas</StatLabel>
              </StatItem>

              <StatItem>
                <StatIcon>
                  <img src={Heart} alt="Experiência" />
                </StatIcon>
                <StatNumber>4</StatNumber>
                <StatLabel>Módulos</StatLabel>
              </StatItem>
            </StatsGrid>

            {/* Buttons */}
            <ButtonSection>
              <ButtonContainer>
                <PrimaryButton onClick={() => history.push('/signup')}>
                  Inscreva-se Agora →
                </PrimaryButton>
                <FreeText>100% online e gratuito</FreeText>
              </ButtonContainer>

              <SecondaryButton onClick={openModal}>
                <Play size={20} style={{ marginRight: 8 }} />
                Assista ao vídeo
              </SecondaryButton>
            </ButtonSection>
          </LeftContent>

          <ImagesGrid>
            <LargeImage>
              <img src={pregnantImage} alt="Imagem principal" />
            </LargeImage>

            <SmallImagesRight>
              <img src={pregnantImage2} alt="Imagem pequena 1" />
              <img src={pregnantImage3} alt="Imagem pequena 2" />
            </SmallImagesRight>

            <BottomImages>
              <div className="bottom-small">
                <img src={pregnantImage4} alt="Imagem inferior pequena" />
              </div>
              <div className="bottom-large">
                <img src={pregnantImage5} alt="Imagem inferior grande" />
              </div>
            </BottomImages>
          </ImagesGrid>
        </Flex>

        {/* WhatsApp floating button */}
        {/* <FloatingButton>
          <a
            href="https://wa.me/5511999999999?text=Olá,%20quero%20saber%20mais!"
            target="_blank"
            rel="noopener noreferrer"
          >
            <WhatsappButton>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="#ffffffff"
              >
                <path d="M20.52 3.48A11.9 11.9 0 0 0 12 0C5.373 0 0 5.373 0 12c0 2.11.55 4.11 1.6 5.86L0 24l6.34-1.65A11.95 11.95 0 0 0 12 24c6.627 0 12-5.373 12-12 0-3.2-1.25-6.2-3.48-8.52zM12 21.75a9.73 9.73 0 0 1-5.05-1.45l-.36-.22-3.77.98.99-3.68-.23-.37A9.74 9.74 0 0 1 2.25 12 9.75 9.75 0 1 1 12 21.75zm5.14-7.63c-.27-.14-1.59-.78-1.83-.87-.24-.09-.42-.14-.6.14s-.69.87-.85 1.05c-.16.18-.31.2-.58.07-.27-.14-1.13-.42-2.16-1.33-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.42.12-.56.12-.12.27-.31.41-.46.14-.15.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.14-.6-1.44-.82-1.97-.22-.52-.44-.45-.6-.46-.15-.01-.33-.01-.5-.01s-.45.07-.69.34c-.24.27-.93.91-.93 2.22 0 1.31.95 2.58 1.08 2.76.14.18 1.87 2.86 4.54 4.01.64.28 1.14.45 1.53.58.64.21 1.22.18 1.68.11.51-.08 1.59-.65 1.82-1.28.23-.63.23-1.16.16-1.28-.07-.12-.27-.18-.55-.32z"/>
              </svg>
            </WhatsappButton>
          </a>
        </FloatingButton> */}
      </MaxWidth>
      {modalOpen && (
        <ModalOverlay onClick={closeModal}>
          <Modal onClick={(e) => e.stopPropagation()}>
            <ModalContent>
              <ModalHeader>
                <div className="modal-profile-section">
                  
                </div>
                <CloseButton onClick={closeModal}>×</CloseButton>
              </ModalHeader>
              
              <ModalBody>
                {welcomeVideo && welcomeVideo.length ? (
                  <div className="video">
                    <PlayerSambaVideos
                      contentReference={welcomeVideo[0].info.reference}
                      controlsToEnable={[
                        'play',
                        'pause',
                        'quality',
                        'fullscreen',
                        'time',
                        'volume',
                        'subtitles',
                        'settings',
                      ]}
                      getEventListeners={() => {}}
                    />
                  </div>
                ) : null}
              </ModalBody>
            </ModalContent>
          </Modal>
        </ModalOverlay>
      )}
    </Container>
  );
}
